import { KeenIcon } from '@/components/keenicons';

const ICON = {
  pass: { icon: 'check-circle', className: 'text-success' },
  fail: { icon: 'cross-circle', className: 'text-danger' },
  warn: { icon: 'information-2', className: 'text-warning' },
  info: { icon: 'information', className: 'text-gray-500' },
};

/**
 * The send-time checklist from GET /demand-letters/{id}/checklist: the
 * jurisdiction's minimum response window and required elements.
 */
const ChecklistPanel = ({ checklist, loading = false }) => {
  if (loading) return <p className="text-xs text-gray-500">Checking…</p>;
  if (!checklist) return null;

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-gray-700">
          Send checklist{checklist.jurisdiction_name ? ` · ${checklist.jurisdiction_name}` : ''}
          {checklist.statute ? ` (${checklist.statute})` : ''}
        </span>
        <span className={`badge badge-sm ${checklist.blocking ? 'badge-danger' : 'badge-success'}`}>
          {checklist.blocking ? 'Not ready' : 'Ready'}
        </span>
      </div>
      <ul className="space-y-1.5">
        {(checklist.items || []).map((item) => {
          const meta = ICON[item.status] || ICON.info;
          return (
            <li key={item.key} className="flex items-start gap-2 text-xs">
              <KeenIcon icon={meta.icon} className={`${meta.className} mt-0.5 shrink-0`} />
              <div>
                <div className="text-gray-800">{item.label}</div>
                {item.detail && <div className="text-gray-500">{item.detail}</div>}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export { ChecklistPanel };
